module.exports = __webpack_public_path__ + "img/r7.d117a04a.jpg";